import { toast } from "react-toastify";
import exchangeInterfaceStore from "../stores/ExchangeInterfaceStore";
import { type WriteContractErrorType } from "@wagmi/core";

const { setInputsValues } = exchangeInterfaceStore;

export const checkIfObjectIsUndefined = (object: object) => {
  return Object.values(object).every((property) => property === undefined);
};

export const preventNegativeOnKeyboard: React.KeyboardEventHandler<
  HTMLInputElement
> = (event) => {
  if (event.code === "Minus" || event.code === "NumpadSubtract") {
    event.preventDefault();
  }
};
export const preventPaste: React.ClipboardEventHandler = (event) => {
  event.preventDefault();
};

export const resetInputValues = () => {
  setInputsValues({
    baseCoinsToPay: "",
    pepeCoinsToReceive: "",
  });
  return;
};

export const handleWriteContractError = (error: WriteContractErrorType) => {
  const errorReason = error.message.split("\n")[1];
  toast.error(`An error occurred: ${errorReason}`);
  return null;
};

export const smoothScroller = (event: React.SyntheticEvent) => {
  event.preventDefault();
  const target = event.target as HTMLAnchorElement;
  const id = target.getAttribute("href")?.replace("#", "");
  const element = document.getElementById(String(id));
  element?.scrollIntoView({
    behavior: "smooth",
  });
};

export const referrerStorage = () => {
  const referrerKey = "referrer";
  const getReferrer = () => localStorage.getItem(referrerKey);

  const setReferrer = (referrer: string) =>
    localStorage.setItem(referrerKey, referrer);
  return {
    getReferrer,
    setReferrer,
  };
};
